import React, { useState, useEffect } from 'react'
import { useLayout } from '@dustin-web/microsite-components/src/hooks'
import classnames from 'classnames'
import { GET_USP_RESULT } from '@dustin-web/microsite-data/src/graphql/content/get-usp-content'
import { useGraphql } from '@dustin-web/microsite-data/src/hooks/use-graphql'
import { GetUspResultQuery } from '@dustin-web/microsite-data/src/graphql/content/generated/graphql-types'
import Link from 'next/link'

const UspBanner = () => {
  const { data, isValidating: loading, error } = useGraphql<GetUspResultQuery>(GET_USP_RESULT)

  const uspData = data?.usp
  const [count, setCount] = useState(0)
  const { responsive } = useLayout()

  const mobileUspCondition = responsive.windowSize.width < 992

  useEffect(() => {
    if (mobileUspCondition) {
      const interval = setInterval(() => {
        setCount(count => {
          if (count == 2) {
            return 0
          } else {
            return count + 1
          }
        })
      }, 6000)
      return () => clearInterval(interval)
    }
  }, [mobileUspCondition])

  if (!data && !loading) {
    return null
  }

  if (error) {
    throw error
  }

  return (
    <div className={classnames('', 'u-bg-black')}>
      <div
        className={classnames(
          'container u-py-8 u-px-16 u-fs-12 d-md-flex u-relative u-color-white',
          {
            'justify-content-between': !mobileUspCondition,
          }
        )}
        id="c-usp-bar">
        {uspData?.usps?.map((usp, index) => (
          <div
            key={index}
            className={classnames('usp-bar-link', {
              UspFadeIn: count == index && mobileUspCondition,
            })}>
            <Link prefetch={false} href={usp?.link.url}>
              {usp?.link.text}
            </Link>
          </div>
        ))}
      </div>
    </div>
  )
}

export default UspBanner
